import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message = _resolveComponent("message")!

  return (_openBlock(), _createBlock(_component_message, { type: "info" }, {
    default: _withCtx(() => [
      _createTextVNode(" Posts are flagged based on a list of keywords that may be of concern. The Flagged Posts section is purely assistive and not intended to be exhaustive of all potential posts of interest. It should be used in conjunction with a manual review of all client posts. We continue to refine the flagging criteria and welcome your feedback. ")
    ]),
    _: 1
  }))
}